import React, { Component } from 'react';
import { DataCompte } from '../../data/DataCompte.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxCompte extends Component {

    static defaultProps = {
        doitInclureComptesSansMandat: false, // par défaut il n'est pas renseigné => on récupère tous les types de mandat
        idAgence: undefined,
        idLotCommercial: undefined,
        idOperation: undefined,
        idRegion: undefined,
        idSociete: undefined,
        idsTypesMandats: undefined,
        label: "Compte",
        listeIdContacts: undefined, // depuis la liste des contacts lors du clic sur poser une dénonciation / Supprimer une dénonciation
        placeholder: "Compte",
    };

    render = () => {

        const { doitInclureComptesSansMandat, idAgence, idLotCommercial, idOperation, idRegion, idSociete, idsTypesMandats, listeIdContacts } = this.props;

        let fetchMethod = null;
        if (!!idSociete) {

            // KP - 16/02/2023 - Fusion ComboBoxCompte avec ComboBoxCompteToutType
            if (idSociete === 1 && !idRegion && !idAgence) {
                const filtres = { idSociete: 1 };
                fetchMethod = () => DataCompte._chargementComptes(filtres, "Nom", false);
            }

            else if (idSociete === 1 && !!idRegion && !!idAgence)
                // Liste des comptes eiffage qui ont un mandat sur le périmètre comprenant idRegion et idAgence
                fetchMethod = () => DataCompte._chargementDesComptesEiffageDeTypeOperationnelOuGestionnaireDeMandatAyantUnMandatSurLePerimetrePasseEnParametre(idRegion, idAgence, doitInclureComptesSansMandat);

            else if (idSociete === 1 && idOperation !== undefined && idLotCommercial !== undefined && idsTypesMandats !== undefined)
                // Liste des comptes eiffage qui ont un mandat sur le périmètre comprenant le lot commercial
                fetchMethod = () => DataCompte._chargementDesComptesEiffageAyantUnMandatSurLePerimetreDuLotCommercialDeCeTypeDeMandat(idOperation, idLotCommercial, idsTypesMandats, doitInclureComptesSansMandat);

            else if (idsTypesMandats !== undefined)
                fetchMethod = () => DataCompte._chargementDesComptesDeLaSocieteDeCeTypeDeMandat(idSociete, idsTypesMandats, listeIdContacts, doitInclureComptesSansMandat);

            else
                // Liste des comptes de la société (on ne refiltre pas sur le mandat vu que c'est fait au niveau de la société et que dans ce cas le mandat est lié à la société)
                fetchMethod = () => DataCompte._chargementDesComptesDeLaSociete(idSociete, doitInclureComptesSansMandat);

        }

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            idValeurParDefaut="0"
            itemKey={item => item.loginCompte}
            itemText={item => `${item.nom} ${item.prenom} - ${item.loginCompte}`.trim()}
            stamp={[doitInclureComptesSansMandat, idAgence, idLotCommercial, idOperation, idRegion, idSociete, idsTypesMandats, listeIdContacts]}
        />;

    };

};